import React, { useState } from "react";
import "./SalesRecovery.css";
import Fold1 from "./nestedFolder/Folds/HeroFold/Fold1";
import Fold3 from "./nestedFolder/Folds/HowItWorks/fold";
import Fold4 from "./nestedFolder/Folds/CoreFeaturesFold/fold";
import Fold5 from "./nestedFolder/Folds/ResultsAndStats/fold";
import Fold6 from "./nestedFolder/Folds/BenefitsFold/fold";
import Fold7 from "./nestedFolder/Folds/TestimonialsFold/fold";
import Fold8 from "./nestedFolder/Folds/ComparisionFold/fold";
import Fold9 from "./nestedFolder/Folds/FAQsFold/fold";
import Navbar from "../../components/NavigationMenu/NavBar";
import RecoverLostForm from "./nestedFolder/Folds/CustomUsecaseForm/CustomUsecaseForm";
import Footer from "../../components/Footer/Footer";

const Insurance = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  const styles = {
    container: {
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "0 0px",
    },
    header: {
      //   padding: "5px 0",
      position: "fixed",
      top: 0,
      width: "100%",
      background: isScrolled
        ? "rgba(255, 255, 255, 0.98)"
        : "rgba(255, 255, 255, 0.95)",
      backdropFilter: "blur(10px)",
      zIndex: 1000,
      transition: "all 0.3s ease",
      boxShadow: isScrolled ? "0 2px 20px rgba(0, 0, 0, 0.1)" : "none",
    },
    nav: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
  };

  return (
    <div className="sales-recovery">
      return (
      <div>
        <header style={styles.header}>
          <div style={styles.container}>
            <nav style={styles.nav}>
              <Navbar />
            </nav>
          </div>
        </header>
        <Fold1 />
        <div style={{ backgroundColor: "#FAF8F7" }}>
          <Fold3 />
        </div>
        <Fold4 />
        <div style={{ backgroundColor: "#FAF8F7" }}>
          <Fold6 />
        </div>
         <Fold7 />
        <div style={{ backgroundColor: "#FAF8F7" }}>
          <Fold8 />
        </div>
        <Fold9 />
        <RecoverLostForm />
        <div style={{padding:"20px"}}>
        <Footer />
        </div>
      </div>

    </div>
  );
};

export default Insurance;
